import { gql } from "@apollo/client";

// A routine's Ask AI sessions, newest first, paginated for the Sessions modal (TF-1505).
export default gql`
  query routineSessions($routineId: String!, $first: Int!, $after: String) {
    chatSessions(
      routineId: $routineId
      first: $first
      after: $after
      orderBy: "-id"
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          created
        }
      }
    }
  }
`;
